<div class="widget-framework">
  <jafar-page-widget [contents]="contentTemplate" [actions]="actionTemplate" >
      <div title>Customer</div>
      <div subtitle> Manage CIP Customers  </div>
  </jafar-page-widget>
</div>

<ng-template #contentTemplate >
  Create new customers in ITSM<br>
</ng-template>

<ng-template #actionTemplate>
  <button mat-flat-button matTooltip="Manage Customers" (click)="buttonClicked()" class="manage-azure-button">
      Go To Customers
      <mat-icon>shortcut</mat-icon>
  </button>
</ng-template>
